<div class="py-2 px-8">
    <ol>
        <ng-container *ngFor="let step of pasos; let last = last; trackBy: trackByFn">
            <li [ngClass]="{'disabled': validateDisable(step)}" class="relative group py-6" [class.current-step]="step.orden === currentStep">
                <ng-container *ngIf="!last">
                    <div class="absolute top-6 left-4 w-0.5 h-full -ml-px"
                         [ngClass]="{'bg-primary': step.orden < currentStep, 'bg-gray-300 dark:bg-gray-600': step.orden >= currentStep}"></div>
                </ng-container>
                <div class="relative flex items-start cursor-pointer">
                    <div
                        class="flex flex-0 items-center justify-center w-8 h-8 rounded-full ring-2 ring-inset ring-transparent bg-card dark:bg-default"
                        [ngClass]="{'bg-primary dark:bg-primary text-on-primary group-hover:bg-primary-800': step.orden < currentStep,
                                                'ring-primary': step.orden === currentStep,
                                                'ring-gray-300 dark:ring-gray-600 group-hover:ring-gray-400': step.orden > currentStep}">
                        <!-- Check icon, show if the step is completed -->
                        <ng-container *ngIf="step.orden < currentStep">
                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                        </ng-container>
                        <!-- Step orden, show if the step is the current step -->
                        <ng-container *ngIf="step.orden === currentStep">
                            <div
                                class="text-md font-semibold text-primary dark:text-primary-500">{{step.orden + 1}}</div>
                        </ng-container>
                        <!-- Step orden, show if the step is not completed -->
                        <ng-container *ngIf="step.orden > currentStep">
                            <div
                                class="text-md font-semibold text-hint group-hover:text-secondary">{{step.orden + 1}}</div>
                        </ng-container>
                    </div>
                    <div class="ml-4">
                        <div class="font-medium leading-4">{{step.titulo}}</div>
                        <div class="mt-1.5 text-md leading-4 text-secondary">{{step.descripcion}}</div>
                    </div>
                </div>
            </li>
        </ng-container>
    </ol>
</div>
